import * as React from "react";
import {cx} from "emotion";

import "./order-summary-table.scss";

import {cs}           from "@Common/react/chain-services";
import {formatMoney1} from "@Common/ui-components/language/format-money";
import {sum}          from "@Common/utils/collections";
import {chain}        from "@Common/utils/fs";

import {CheckShowPricing} from "../../../../common/check-show-pricing";

export const OrderSummaryTable = ({subtitle, lines, isNDM}) => cs(
    ({}) => (
        <div className="table order-summary-table-75e" xd-qa-type="card" xd-qa-name="Order Summary">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Order Summary">
                    Order Summary
                </div>
                <div className="sub-title" xd-qa-type="label" xd-qa-name="Items">
                    {subtitle}
                </div>
            </div>

            {cs(
                ({}, next) => CheckShowPricing({next}),
                () => (
                    <div className="table">
                        <div className="table-head">
                            <div className="label"/>
                            <div className="qty" xd-qa-type="label" xd-qa-name="Quantity">Qty</div>
                            <div className="amount" xd-qa-type="label" xd-qa-name="Amount Due">Amount Due</div>
                        </div>
                        <div className="sections">
                            <div className="section">
                                {lines.map((line, i) => (
                                    <div className={cx("line", line.className)} key={i}>
                                        <div className="label" xd-qa-type="text" xd-qa-name={getXdQaName(line)}>
                                            {line.label && <>
                                                {isNDM? line.label.replace(/Saturation/g, 'Neighborhood Search') : line.label}
                                                {line.unitPrice!== undefined && <>
                                                    {" "}({formatMoney1(line.unitPrice?? 0.00)} each)
                                                </>}
                                            </>}
                                            {!!line.details?.length && (
                                                <div className="details">
                                                    {line.details.map(({text, label}, j) => (
                                                        <p className="detail" xd-qa-type="text" xd-qa-name={text} key={j}>
                                                            {label}
                                                        </p>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        <div className="qty" xd-qa-type="text" xd-qa-name={(line.label ?? "Address Lists") + " Quantity"}>
                                            {line.qty != null? line.qty: " "}
                                        </div>
                                        <div className="amount" xd-qa-type="text" xd-qa-name={(line.label ?? "Address Lists") + " Amount"}>
                                            {line.amount != null ? (
                                                formatMoney1(line.amount)
                                            ) : (line.qty && line.unitPrice) ? (
                                                formatMoney1(line.qty * line.unitPrice)
                                            ) : (
                                                " "
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="section">
                                <div className="line big">
                                    <div className="label" xd-qa-type="label" xd-qa-name="Balance">
                                        Balance
                                    </div>
                                    <div className="amount" xd-qa-type="label" xd-qa-name="Balance Amount">
                                        {!lines ? (
                                            "--"
                                        ) : chain(
                                            sum(lines, (line) => line.amount ?? (
                                                line.unitPrice && line.qty ? (
                                                    line.unitPrice * line.qty
                                                ) : (
                                                    0
                                                )
                                            )),
                                            formatMoney1,
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                )
            )}
        </div>
    ),
);

const getXdQaName = (line) => {
    return line.label && (
        line.label + 
        (
            line.unitPrice == null ? "" : (
                " (" + formatMoney1(line.unitPrice?? 0.00) + " each)"
            )
        )
    )
};